import api from './api';

const errorMessage = (error, fallback) => error.response?.data?.message || fallback;

export const categoryService = {
  // Current user's categories with post counts
  getMyCategories: async () => {
    try {
      const response = await api.get('/creators/me/categories');
      return response.data;
    } catch (error) {
      throw new Error(errorMessage(error, 'Failed to load categories'));
    }
  },

  // A creator's categories as visible to the current viewer
  getCreatorCategories: async (creatorId) => {
    try {
      const response = await api.get(`/creators/${creatorId}/categories`);
      return response.data;
    } catch (error) {
      throw new Error(errorMessage(error, 'Failed to load categories'));
    }
  },

  createCategory: async (name) => {
    try {
      const response = await api.post('/creators/me/categories', { name });
      return response.data;
    } catch (error) {
      throw new Error(errorMessage(error, 'Failed to create category'));
    }
  },

  renameCategory: async (id, name) => {
    try {
      const response = await api.put(`/creators/me/categories/${id}`, { name });
      return response.data;
    } catch (error) {
      throw new Error(errorMessage(error, 'Failed to rename category'));
    }
  },

  deleteCategory: async (id) => {
    try {
      await api.delete(`/creators/me/categories/${id}`);
    } catch (error) {
      throw new Error(errorMessage(error, 'Failed to delete category'));
    }
  },

  mergeCategory: async (id, targetCategoryId) => {
    try {
      await api.post(`/creators/me/categories/${id}/merge`, { targetCategoryId });
    } catch (error) {
      throw new Error(errorMessage(error, 'Failed to merge categories'));
    }
  }
};

export default categoryService;
